import React from "react";
import useJourneyLeg from "../../hooks/useJourneyLeg";
import AtocSeatReservations from "./AtocSeatReservations";
import EuSeatReservations from "./EuSeatReservations";
import NoSeatAssigned from "./NoSeatAssigned";
import SplitSaveReservations from "./SplitSaveReservations";
const isEuBooking = (seatReservations) => seatReservations.some((seatReservation) => !!seatReservation.passengerName);
const isSplitSaveBooking = (seatReservations) => seatReservations.some((seatReservation) => !!seatReservation.originStation);
const SeatReservations = ({ legId }) => {
  const { seatReservations } = useJourneyLeg(legId);
  if (!seatReservations || seatReservations.length === 0) {
    return null;
  }
  if (!seatReservations[0].seatNumber) {
    return /* @__PURE__ */ React.createElement(NoSeatAssigned, {
      seatClass: seatReservations[0].seatClass
    });
  }
  if (isEuBooking(seatReservations)) {
    return /* @__PURE__ */ React.createElement(EuSeatReservations, {
      seatReservations
    });
  }
  if (isSplitSaveBooking(seatReservations)) {
    return /* @__PURE__ */ React.createElement(SplitSaveReservations, {
      seatReservations
    });
  }
  return /* @__PURE__ */ React.createElement(AtocSeatReservations, {
    seatReservations
  });
};
var SeatReservations_default = SeatReservations;
export {
  SeatReservations_default as default
};
